module.exports = __webpack_public_path__ + "img/building.96567bdb.png";